import { useState } from "react";
import { Eye, EyeOff, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function MaskedField({ value, testid }) {
  const [shown, setShown] = useState(false);
  const [copied, setCopied] = useState(false);
  if (!value) return <span className="text-slate-400">—</span>;
  const mask = (s) => {
    const str = String(s);
    if (str.length <= 4) return "•".repeat(str.length);
    return "•".repeat(str.length - 4) + str.slice(-4);
  };
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      toast.success("Copied");
      setTimeout(() => setCopied(false), 1500);
    } catch {}
  };
  return (
    <span className="inline-flex items-center gap-1.5 tabular-nums">
      <span className="font-mono text-[13px]">{shown ? value : mask(value)}</span>
      <button
        type="button"
        onClick={() => setShown((v) => !v)}
        className="p-1 rounded hover:bg-slate-100 text-slate-500"
        aria-label={shown ? "Hide value" : "Reveal value"}
        data-testid={testid ? `${testid}-toggle` : undefined}
      >
        {shown
          ? <EyeOff className="h-3.5 w-3.5" strokeWidth={1.75} />
          : <Eye className="h-3.5 w-3.5" strokeWidth={1.75} />}
      </button>
      <button
        type="button"
        onClick={onCopy}
        className="p-1 rounded hover:bg-slate-100 text-slate-500"
        aria-label="Copy value"
        data-testid={testid ? `${testid}-copy` : undefined}
      >
        {copied
          ? <Check className="h-3.5 w-3.5 text-emerald-600" strokeWidth={1.75} />
          : <Copy className="h-3.5 w-3.5" strokeWidth={1.75} />}
      </button>
    </span>
  );
}
